module.exports = __webpack_public_path__ + "img/rarity-bg-1.0c4b555a.png";